<div
  class="c-rewardBox"
  theming
  [themingGroup]="boxThemingGroup"
  [themingAsset]="boxAsset"
  [themingOverride]="themingOverride">
  <div
    class="c-rewardBox__icon"
    theming
    [themingGroup]="iconThemingGroup"
    [themingAsset]="iconAsset"
    [themingOverride]="themingOverride"></div>

  <span class="c-rewardBox__number">
    {{ numberValue | notRoundingBeautifyNumber: ('common.culture' | translate) }}
  </span>
</div>
